import { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { Switch } from '../../../components/ui/switch';
import { Label } from '../../../components/ui/label';
import { Button } from '../../../components/ui/button';
import { toast } from 'sonner';
import { mfaSecurityApi } from '../../../lib/api';

// Muss zu MFA_SENSITIVE_SECTIONS/-KEYS in backend_fastapi/app/rbac/mfa_policy.py passen.
const SENSIBLE_RECHTE = [
  'Benutzer- und Rechteverwaltung (global und am Standort)',
  'Sicherheitseinstellungen und Datenschutz',
  'Buchhaltung: Finanzdaten, Zahlungen, Mahnwesen, Finanzdokumente',
  'Zahlungswesen und Integrationen',
  'Exporte personenbezogener Daten (Personenlisten, Datenexport, Logs)',
];

const MfaSecuritySettings = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [enforceSensitive, setEnforceSensitive] = useState(false);

  const load = async () => {
    setIsLoading(true);
    try {
      const cfg = await mfaSecurityApi.get();
      setEnforceSensitive(!!cfg.enforceSensitive);
    } catch {
      toast.error('2FA-Richtlinie konnte nicht geladen werden');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    setIsSaving(true);
    try {
      await mfaSecurityApi.update({ enforceSensitive });
      toast.success('2FA-Richtlinie gespeichert');
    } catch {
      toast.error('2FA-Richtlinie konnte nicht gespeichert werden');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Sicherheit & 2FA</h1>
        <p className="text-muted-foreground">Zwei-Faktor-Anmeldung für Konten mit sensiblen Rechten.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5" /> 2FA-Pflicht</CardTitle>
          <CardDescription>
            Maßgeblich sind die Rechte eines Kontos, egal ob aus einer Rolle oder einem individuellen Recht.
            Standardmäßig aus. Nach dem Einschalten werden betroffene Konten ohne 2FA spätestens nach etwa
            15 Minuten abgemeldet und richten sie bei der nächsten Anmeldung ein. Ausnahmen je Benutzer
            setzen Sie in der Benutzerverwaltung (Reiter „Sicherheit").
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {isLoading ? (
            <p className="text-sm text-muted-foreground">Lade Einstellungen…</p>
          ) : (
            <>
              <div className="flex items-center justify-between gap-4 rounded border p-3">
                <div>
                  <Label className="text-sm font-medium">2FA für sensible Rechte erzwingen</Label>
                  <ul className="mt-1 list-disc pl-5 text-xs text-muted-foreground">
                    {SENSIBLE_RECHTE.map((text) => <li key={text}>{text}</li>)}
                  </ul>
                </div>
                <Switch checked={enforceSensitive} onCheckedChange={setEnforceSensitive} />
              </div>
              <div className="flex justify-end">
                <Button onClick={save} disabled={isSaving}>{isSaving ? 'Speichern…' : 'Speichern'}</Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default MfaSecuritySettings;
